import { render, staticRenderFns } from "./observe-detail.vue?vue&type=template&id=662d4638&scoped=true"
import script from "./observe-detail.vue?vue&type=script&lang=js"
export * from "./observe-detail.vue?vue&type=script&lang=js"
import style0 from "./observe-detail.vue?vue&type=style&index=0&id=662d4638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d4638",
  null
  
)

export default component.exports